module Client.Locations


open Client
open Client.Services
open Shared
open global.Elmish
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.UseElmish
open Fable.Core.Experimental
open System.Text.RegularExpressions

let view = React.functionComponent (fun (inputProps: {| model : LoggedInModel; |}) ->
  let classes = Styles.useStyles ()
  let (locations, setLocations) = React.useState(Array.empty<ContactLocation>)
  let (error, setError) = React.useState<string option>(None)
  let (isLoading, setIsLoading) = React.useState(true)

  React.useEffectOnce(fun () ->
    promise {
      let! authHeader = Services.getAuthHeader()
      try
        let decoder = Services.decoder<Shared.ContactLocation []>
        let! response = Fetch.tryGet("/api/Locations", headers = [ authHeader ], decoder = decoder)
        match response with
        | Ok v ->
          setLocations v
        | Result.Error fetchError ->
          match fetchError with
          | FetchError.DecodingFailed _ -> setError (Some "Problem parsing response")
          | FetchError.FetchFailed msg -> setError (Some "Problem fetching locations")
          | FetchError.NetworkError _ -> setError (Some "Problem fetching locations")
          | FetchError.PreparingRequestFailed _ -> setError (Some "Problem fetching locations")
      with e ->
        setError (Some e.Message)
      setIsLoading false
    } |> ignore
  )

  let renderBreadcrumbs () =
    Mui.breadcrumbs [
      breadcrumbs.children [
        Mui.link [
          prop.href (Client.Pages.toHash Pages.Page.Home)
          link.children "Home"
        ]
        Mui.typography [
          typography.color.textPrimary
          typography.children "Locations"
        ]
      ]
    ]

  let renderLocation loc =
    let customerId =
        match loc.CustomerId with
        | MasterCustomerId v -> v
        | CustomerId v -> v

    Mui.listItem [
        listItem.alignItems.flexStart
        listItem.button true
        listItem.component' "a"
        prop.href (Client.Pages.toHash (Pages.Page.Location customerId))
        listItem.children [
            Mui.listItemText [
                listItemText.primary loc.CustomerName
                listItemText.secondary loc.Address
            ]
            Mui.listItemSecondaryAction [
              listItemSecondaryAction.children [
                Mui.grid [
                  grid.container true
                  grid.direction.row
                  grid.spacing._2
                  grid.children [
                    Mui.grid [
                      grid.item true
                      grid.children [
                        Mui.button [
                          prop.type'.button
                          button.fullWidth true
                          button.variant.contained
                          button.color.default'
                          button.startIcon (printerIcon [])
                          button.children "Equipment"
                          button.href (Client.Pages.toHash (Pages.Page.LocationEquipments customerId))
                        ]
                      ]
                    ]
                    Mui.grid [
                      grid.item true
                      grid.children [
                        Mui.button [
                          prop.type'.button
                          button.fullWidth true
                          button.variant.contained
                          button.color.default'
                          button.startIcon (clipboardIcon [])
                          button.children "Invoices"
                          button.href (Client.Pages.toHash (Pages.Page.LocationInvoices customerId))
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
        ]
    ]

  Html.div [
    renderBreadcrumbs()
    Html.h2 "Locations"

    if isLoading then
      Mui.circularProgress []
    else
      match error with
      | Some msg -> Html.p [ prop.style [ style.color.red ]; prop.text msg ]
      | None ->
        if Array.isEmpty locations then
          Html.p "No locations found"
        else
          Html.div [
            Html.p "Choose a location from the following list and you will be presented with data filtered by the selected location."

            Mui.list [
              prop.width 100
              list.children [
                for loc in locations do
                  renderLocation loc
              ]
            ]
          ]
  ]
)